import { proxy } from 'valtio'
import { http } from '@/shared/api'

export type PointRuleInputConfig =
  | { type: 'number'; source: string }
  | { type: 'map'; source: string; map: string }
  | { type: 'constant'; value: number }
  | { type: 'step'; source: string; step: number; min?: number }
  | { type: 'range_map'; source: string; map: string }
  | { type: 'case_range_map'; source: string; selector_source: string; map: string }
  | { type: 'case_map'; source: string; selector_source: string; map: string }

export interface PointRuleItem {
  formula: string
  inputs: Record<string, PointRuleInputConfig>
  [key: string]: unknown
}

export type PointRuleModelBucket = Record<string, PointRuleItem>
export type PointRuleConfigData = Record<string, PointRuleModelBucket>
export type PointRuleConfigStatus = 'idle' | 'loading' | 'ready' | 'error'

export const pointRuleConfigStore = proxy<{
  pointRuleConfig: PointRuleConfigData | null
  status: PointRuleConfigStatus
}>({
  pointRuleConfig: null,
  status: 'idle',
})

export async function fetchPointRuleConfig() {
  pointRuleConfigStore.status = 'loading'

  try {
    const response = await http.post<PointRuleConfigData>('/zs/AiCanvasTask/getPointRuleConfig')
    if (response.code === 1 && response.data) {
      pointRuleConfigStore.pointRuleConfig = response.data
      pointRuleConfigStore.status = 'ready'
      return true
    }
  } catch (error) {
    console.log('[PointRuleConfig] Failed to fetch point rule config:', error)
  }

  pointRuleConfigStore.status = 'error'
  return false
}
